import { CSSProperties, PropsWithChildren } from 'react'
import Styles from './LoadingShimmerer.module.scss'
import cx from 'classnames'

interface Props {
  isOverlay?: boolean
  show?: boolean
  className?: string
  shimmererClassName?: string
  borderRadius?: number | string
  style?: CSSProperties
}

export const LoadingShimmerer = ({
  children,
  className,
  isOverlay = false,
  shimmererClassName,
  show = true,
  borderRadius = 10,
  style,
}: PropsWithChildren<Props>) => {
  return (
    <div className={cx(Styles.shimmererContainer, className)} style={{ ...style, borderRadius }}>
      {show && <div className={cx(Styles.shimmerer, shimmererClassName, { [Styles.isOverlay]: isOverlay })} />}
      {children}
    </div>
  )
}
